import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, Instagram, Facebook, Linkedin } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="inline-flex bg-white p-3">
            <img src="/assets/imodeff-logo.png" alt="Imodeff" className="h-12 w-auto object-contain" />
          </Link>
        </div>
        <div>
          <h4 className="text-[13px] font-semibold tracking-[0.15em] mb-4">{t.footer.contact}</h4>
          <a href="mailto:gestion@imargo.be" className="block text-neutral-300 hover:text-white transition text-sm">gestion@imargo.be</a>
          <a href="tel:+3226441020" className="block text-neutral-300 hover:text-white transition text-sm mt-1">02 644 10 20</a>
        </div>
        <div>
          <h4 className="text-[13px] font-semibold tracking-[0.15em] mb-4">{t.footer.address}</h4>
          <p className="text-neutral-300 text-sm leading-relaxed">Avenue Louise 335,<br />1050 Bruxelles</p>
        </div>
        <div className="flex md:justify-end items-start gap-4">
          <a href="#" aria-label="Instagram" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#e11f3a] hover:text-[#e11f3a] transition">
            <Instagram className="w-4 h-4" />
          </a>
          <a href="#" aria-label="Facebook" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#e11f3a] hover:text-[#e11f3a] transition">
            <Facebook className="w-4 h-4" />
          </a>
          <a href="#" aria-label="LinkedIn" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#e11f3a] hover:text-[#e11f3a] transition">
            <Linkedin className="w-4 h-4" />
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between gap-4 text-xs text-neutral-400">
          <span>{t.footer.copyright}</span>
          <span className="hidden md:inline text-neutral-500">Anonymous analytics for internal use — no personal data collected.</span>
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="w-9 h-9 border border-white/20 flex items-center justify-center hover:border-[#e11f3a] hover:text-[#e11f3a] transition" aria-label="Back to top">
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
